import React from 'react';
import Icon from '@atlaskit/icon';
var AlignLeftIconGlyph = function AlignLeftIconGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    focusable: "false",
    "data-testid": props['data-testid'],
    "aria-label": props['aria-label']
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: props.className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

/**
 * __AlignLeftIcon__
 */
var AlignLeftIcon = function AlignLeftIcon(_ref) {
  var label = _ref.label,
    primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Icon, {
    label: label,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    size: size,
    testId: testId,
    glyph: AlignLeftIconGlyph
  });
};
export default AlignLeftIcon;